'use client';
import { useStateRef } from '@s7/hooks';

const useInteractivityController = ()=>{
    const [interactive, setInteractive] = useStateRef(false);
    const disableInteractivity = ()=>setInteractive(true);
    return [
        interactive,
        disableInteractivity
    ];
};

export { useInteractivityController };
//# sourceMappingURL=useInteractivityController.js.map
